export default {
  props: ['menu'],

  data() {
    return {
      virtualList: []
    };
  },

  created() {
    this.union_vr();
  },

  methods: {
    async union_vr() {
      let res = await this.$http.getHomeUnion_vr({
        num: this.menu.num,
        menu_id: this.menu.menu_id
      });
      this.virtualList = res || [];
    }

  }
};